<template>
    <span class="border-2 border-white rounded bg-transparent p-1"><slot /></span>
</template>

<script>
export default {
    name: "AtomLabel",
}
</script>
